import { useEffect } from 'react'
import { QuestionViewFrame } from '../../questions/types'
import { ITimeline } from './types'

export default function useTimelineFrame(timeline: ITimeline, frame: QuestionViewFrame = 0, startFrame = true) {
  useEffect(() => {
    if (startFrame && !timeline.frameStarted(frame)) {
      timeline.frameStart(frame)
    }
    return () => {
      if (timeline.frameStarted(frame)) {
        timeline.frameCommit(frame)
      }
    }
  }, [timeline, frame, startFrame])

  return useTimelineFrameInteractionStart(timeline, frame)
}

const useTimelineFrameInteractionStartMemo = new WeakMap<ITimeline, [QuestionViewFrame, () => void]>()
export function useTimelineFrameInteractionStart(timeline: ITimeline, frame: QuestionViewFrame = 0): () => void {
  const memo = useTimelineFrameInteractionStartMemo.get(timeline)
  if (memo && memo[0] === frame) {
    return memo[1]
  } else {
    const interactionStart: () => void = () => void timeline.frameInteractionStart(frame)
    useTimelineFrameInteractionStartMemo.set(timeline, [frame, interactionStart])
    return interactionStart
  }
}
